/****************************************************
 * Module Name:  welcomeDashboard.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import UserBifurcationPieChart from "./userBifurcationPieChart";
import { Box, Container } from "@mui/material";
import Constants from "../../utility/constants";
import MixDiamondViewStockBarChart from "./mixDiamondViewStockBarChart";
import DelayedLotReceiveBarChart from "./delayedLotReceiveBarChart";
import AboveMaxQuantityBarChart from "./aboveMaxQuantityBarChart";
import BelowMinQuantityBarChart from "./belowMinQuantityBarChart";
import UsersByLocation from "./allUserByLocationPieChart";
import BucketTransactions from "./bucketTransactionLineChart";
import UserGradeCount from "./userGradePieChart";
import KapanStatusSummaryPieChart from "./kapanStatusSummaryPieChart";
import IgiLabStatsPieChart from "./igiLabStatsPieChart";
import HrdLabStatsPieChart from "./hrdLabStatsPieChart";
import GiaLabStatsPieChart from "./giaLabStatsPieChart";

function WelcomeDashboard() {
  return (
    <div>
      <Container maxWidth="xxl">
        <Box
          display={"flex"}
          justifyContent={"center"}
          flexWrap={"wrap"}
          gap={2}
          mt={2}
          pb={2}
        >
          {/* User Bifurcation Pie Chart On Dashboard */}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.MASTER_USER
          ) !== undefined && <UserBifurcationPieChart />}

          {/* Delayed Lot Receive Bar Chart On Dashboard */}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.MANUFACTURING_OPERATION_LOTINTIMATION
          ) !== undefined && <DelayedLotReceiveBarChart />}

          {/* Mix Diamond Stock Bar Chart On Dashboard */}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.MIX_VIEW_STOCK
          ) !== undefined && <MixDiamondViewStockBarChart click={true} />}

          {/* Quantity of bucket below Min Quantity Bar Chart On Dashboard */}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.MIX_BUCKET
          ) !== undefined && <BelowMinQuantityBarChart />}

          {/* Quantity of bucket above max Quantity Bar Chart On Dashboard */}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.MIX_BUCKET
          ) !== undefined && <AboveMaxQuantityBarChart />}

          {/* No. of system users by User Type and Location pie Chart On Dashboard */}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.MASTER_USER
          ) !== undefined && <UsersByLocation />}

          {/* Bucket Transaction by date Line Chart On Dashboard */}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.MIX_REPORT_BUCKETTRANSACTION
          ) !== undefined && <BucketTransactions />}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.MASTER_USER
          ) !== undefined && <UserGradeCount />}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.REPORT_KAPAN_KAPANSTATUSSUMMARY
          ) !== undefined && <KapanStatusSummaryPieChart />}

          {/* LAB Stats count group by status - Pie Chart */}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.WORKER_IGI
          ) !== undefined && <IgiLabStatsPieChart />}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.WORKER_HRD
          ) !== undefined && <HrdLabStatsPieChart />}

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid === Constants.PERMISSIONS.WORKER_GIA
          ) !== undefined && <GiaLabStatsPieChart />}

        </Box>
      </Container>
    </div>
  );
}

export default WelcomeDashboard;
